export const isSameStation =
  (
    errorMsg: string,
    fields: { firstFieldName: string; secondFieldName: string }
  ) =>
  (field: any) => {
    const startStation = field[fields.firstFieldName].value;
    const secondStation = field[fields.secondFieldName].value;

    if (startStation === secondStation) {
      return errorMsg;
    }
    return null;
  };
